<template>

    <iframe :src="query?`https://prod-ws-indiotienda.azurewebsites.net?${query}`:`https://prod-ws-indiotienda.azurewebsites.net`" frameborder="0" style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
  
</template>

<script>
import tagFunctions from '@/utils/tagFunctions.js'
export default {
  name: "tienditascolormexico",

  components: {

  },
  computed: {
    query(){
      return Object.keys(this.$router.currentRoute.query).map((x) => {
    return x + '=' + this.$router.currentRoute.query[x];
}).join('&');
    }
  },
  created() {},
  data() {
    return {
    }
  },
  mounted() {
    tagFunctions.evPageViewPush('Tienditascolormexico')
  },
  methods: {},
};
</script>


